module.exports = __webpack_public_path__ + "img/Vuyap_heart_blue.586f7860.svg";